import React from 'react';
import * as types from '../api/types';
import { PRICE_SOURCE_LABELS } from '../utils/priceChart';

const TONES: Record<types.JobPriceSource, string> = {
  CATALOG: 'bg-gray-100 text-gray-700',
  CHART: 'bg-blue-50 text-blue-800',
  MANUAL: 'bg-amber-50 text-amber-800',
};

/** Small pill showing where a job line's unit price came from. */
export function PriceSourceBadge({ source }: { source: types.JobPriceSource }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold ${TONES[source]}`}>
      {PRICE_SOURCE_LABELS[source]} price
    </span>
  );
}
